import React from 'react';
import { connect } from "react-redux";

import { Card, Typography, Divider } from '../ecosystem'

const FamilyManagementCard = ({ title, children, removeBSWPharmacy }) => {
    return (
        <Card className={`family-management-card ${removeBSWPharmacy ? 'family-management-card--removeBSWPharmacy' : '' }`}>
            {!removeBSWPharmacy &&
                <>
                <div className='family-mgmt-card-title'>
                    <Typography type="heading-01" tag="h3" color="$color-secondary-a2">{title}</Typography>
                </div>
                <Divider
                    mLeft="none"
                    mRight="none"
                    mTop="small"
                    mBottom="small"
                />
                </>
                
            }
           
            <div className="family-mgmt-card-body">
                {children}
            </div>
        </Card>
    )
}
const mapStateToProps = (state) => {
    return {
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};
export default connect(mapStateToProps, null)(FamilyManagementCard);

